'use client';

import { parseAsString, useQueryStates } from 'nuqs';

import { PageMain } from '@/app/(app)/page-main';
import { PaginationWithEllipses } from '@/components/pagination';

import { ANALYTICS_AI_COACH_PAGE, ANALYTICS_CALLS_DASHBOARD_PAGE } from '../nav';
import { CallTable } from './components/call-table';
import { CallsTableProvider, useCallsTableCtx } from './components/call-table-provider';

function Paginate() {
  const {
    searchState: { page, pageSize },
    setPage,
    totalCount,
  } = useCallsTableCtx();
  const totalPages = Math.ceil(totalCount / pageSize);
  return <PaginationWithEllipses className='mt-4' currentPage={page} totalPages={totalPages} onPageChange={setPage} />;
}

export function CallAnalyticsTablePageContent() {
  const [params] = useQueryStates({
    csr: parseAsString.withDefault(''),
    return_to: parseAsString.withDefault(''),
  });

  const breadcrumbs =
    params.return_to == 'dashboard'
      ? [{ label: ANALYTICS_AI_COACH_PAGE.label, href: ANALYTICS_AI_COACH_PAGE.url }]
      : [];

  return (
    <PageMain title={ANALYTICS_CALLS_DASHBOARD_PAGE.label} breadcrumbs={breadcrumbs}>
      <div className='@container/main space-y-4'>
        <CallsTableProvider>
          <CallTable csr={params.csr} />
          <Paginate />
        </CallsTableProvider>
      </div>
    </PageMain>
  );
}
